// submitBtnClickHandlerUtil.js
// Utility function for submitBtnClickHandler logic
import {
    getBannerDetails,
} from 'src/common/redux/actions';
import { getOrderStatusDetailsFunc } from '../redux/saga/dataServices';
import { isUsageSubmissionProcessing } from 'src/utils/util';

const submitBtnClickHandlerUtil = async ({
    dispatch,
    setLockLoader,
    checkIfOrderIsSubmitted,
    setOrderLockedData,
    setShowOrderLockedPopup,
    setUsageProcessingPopup,
    myCaseRefId,
    myCaseResourceType,
    showReportPayment,
    reportPaymentGridData,
    setFooterButtonStatuses,
    footerButtonStatuses,
    submit,
    createReportPaymentSubmissionProductsArr,
    reportUsageFormObj,
    setReportUsageFormObj,
    submitUsageOrder,
    usageDetails,
    setShowSurgeryNonUsePopup,
    next
}) => {
    dispatch(getBannerDetails());
    setLockLoader(true);
    const orderLockedData = await checkIfOrderIsSubmitted('Submitted');
    setOrderLockedData(orderLockedData);
    if (!orderLockedData?.isOrderLocked && myCaseResourceType !== 'reportPayment') {
        const orderStatus = await getOrderStatusDetailsFunc(myCaseRefId);
        if (orderStatus === 'error') {
            setLockLoader(false);
            return;
        }
        if (isUsageSubmissionProcessing(orderStatus)) {
            setLockLoader(false);
            setUsageProcessingPopup({
                myCaseRef: myCaseRefId,
                userId: orderStatus.userId,
            });
            return;
        }
    }
    if (orderLockedData?.isOrderLocked) {
        setLockLoader(false);
        setShowOrderLockedPopup({
            show: true,
            myCaseRef: orderLockedData?.myCaseRef ? orderLockedData?.myCaseRef : myCaseRefId,
            modifiedBy: orderLockedData?.user,
        });
    } else if (
        myCaseResourceType === 'reportPayment' &&
        showReportPayment &&
        reportPaymentGridData.length > 0 &&
        myCaseRefId
    ) {
        setFooterButtonStatuses(
            footerButtonStatuses.map((x) =>
                x.btnName === submit ? { ...x, isBtnDisable: false, btnVisibility:false } :                
                x.btnName === next ? { ...x, isBtnDisable: true, btnVisibility:true } : x
            )
        );
        let updatedItem = [...reportPaymentGridData];
        const reportPaymentProductsArr = createReportPaymentSubmissionProductsArr(
            updatedItem,
            reportUsageFormObj.products?.length > 0 ? reportUsageFormObj?.products : [],
            myCaseResourceType
        );
        const reportPaymentRequestObj = {
            ...reportUsageFormObj,
            isSapSubmission: true,
            products: reportPaymentProductsArr,
            isPriceUpdated: reportPaymentGridData.some((item) => item.isPriceUpdated),
        };
        setReportUsageFormObj(reportPaymentRequestObj);
        submitUsageOrder(reportPaymentRequestObj);
    } else {
        if (
            usageDetails?.tissueAndNonTissueItemsInSurgery &&
            reportUsageFormObj.products?.length > 0 &&
            !(
                reportUsageFormObj.products.some((item) => item.salesOrg === 'S002') &&
                reportUsageFormObj.products.some((item) => item.salesOrg === 'S030')
            )
        ) {
            setLockLoader(false);
            setShowSurgeryNonUsePopup(true);
        } else {
            submitUsageOrder(null, orderLockedData);
        }
    }
    localStorage.removeItem('myCaseRefUsage');
};

export default submitBtnClickHandlerUtil;
